import { render } from "./formations.vue?vue&type=template&id=5ec2fc4e"
import script from "./formations.vue?vue&type=script&lang=js"
export * from "./formations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__